<template>
  <banners>
    <div class="mx-auto max-w-screen-lg px-4 py-4 md:px-10">
      <h1 class="my-4 text-left text-2xl text-dark-blue md:my-6">
        Add Carriers
      </h1>
      <div
        class="flex flex-col md:rounded-md md:border md:border-light-gray md:p-8 md:shadow-primary"
      >
        <h2 class="mt-1 text-left text-1lg text-dark-blue">
          Request Access to {{ carrierName }}
        </h2>
        <p class="my-5 text-left text-1md text-dark-gray">
          For you to be able to join {{ carrierName }}, we need an authorized
          representative of the carrier to grant you access.
        </p>
        <div v-if="!maskedContacts.length">
          <contact-recipients
            v-if="filterCensusEmails.length"
            title="Recipients of request"
            :show-see-more="false"
            :items-to-show="filterCensusEmails.length"
            :contacts="contactRecipients"
          />
        </div>
        <div v-else>
          <request-recipients
            title="Recipients of request"
            :items="maskedContacts"
          />
        </div>
        <div class="flex flex-col-reverse justify-end gap-4 md:flex-row">
          <button-main
            class="self-center md:max-w-max"
            variant="secondary"
            @click="$router.push('/dispatcher/add-carriers')"
          >
            Back
          </button-main>
          <button-main
            :is-loading="loading"
            class="self-center md:max-w-max"
            @click="sendRequest"
          >
            Send Request
          </button-main>
        </div>
      </div>
    </div>
  </banners>
</template>
<script>
import ButtonMain from '@/components/Button.vue';
import Banners from '@/components/Banners.vue';
import ContactRecipients from '@/views/signup/dispatcher/ContactRecipients.vue';
import RequestRecipients from '@/views/signup/dispatcher/RequestRecipients.vue';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'AddCarrier',
  components: {
    Banners,
    ButtonMain,
    RequestRecipients,
    ContactRecipients,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    carrierName() {
      return this.$store.state.carriers?.carrierDetails?.legal_name || '';
    },
    carrierId() {
      return this.$store.state.carriers?.carrierDetails?.id || '';
    },
    maskedContacts() {
      return this.$store.state.carriers?.maskedContacts || [];
    },
    contactRecipients() {
      const carrier = this.$store.state.carriers?.carrierDetails;
      return carrier?.email_addresses || [];
    },
    filterCensusEmails() {
      return this.contactRecipients?.filter(
        (email) => email.is_type === 'census'
      );
    },
  },
  async created() {},
  methods: {
    // Redirect to OAuth 2 screen if able to
    // create the onboarding packet
    async redirectToCreateDispatcherOnboardingPacket() {
      await this.$store.dispatch('users/serverRefreshCurrentUser');
      return this.$router.push('/dispatcher/access-pending');
    },
    async createDispatcherConnection() {
      console.log('creating dispatcher connection');
      const res = await this.$store.dispatch(
        'dispatchers/createDispatcherConnection',
        {
          carrier_id: this.carrierId,
        }
      );
      if ([200, 201].includes(res.status)) {
        await this.redirectToCreateDispatcherOnboardingPacket();
      } else {
        // handle error for updating user details
        toastResponse(this, res, null);
      }
    },
    async sendRequest() {
      this.loading = true;
      await this.createDispatcherConnection();
      this.loading = false;
    },
  },
};
</script>
<style>
.max-h-max {
  height: max-content;
}
</style>
